import React, { useState } from 'react';
import { ChevronRight } from 'lucide-react';

interface DrawerSectionProps {
  title: string;
  /** Sunto mostrato accanto al titolo quando la sezione è chiusa. */
  summary?: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

/**
 * Toggle di sezione del drawer "Nuova anagrafica": chevron rosa Flusia,
 * titolo maiuscoletto grigio, sunto inline, contenuto a filo senza indent
 * (stesso pattern del drawer attività, design congelato 10/08).
 */
export function DrawerSection({ title, summary, defaultOpen = false, children }: DrawerSectionProps) {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div className="mt-1">
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        className="flex w-full items-center gap-1.5 rounded px-1.5 py-1.5 -mx-1.5 text-left hover:bg-[rgba(55,53,47,0.08)] dark:hover:bg-white/[0.06] transition-colors"
      >
        <ChevronRight
          className={`w-3.5 h-3.5 flex-shrink-0 text-[#E91E8C] transition-transform ${open ? 'rotate-90' : ''}`}
          strokeWidth={2}
        />
        <span className="text-[11px] font-medium uppercase tracking-wide text-[rgba(55,53,47,0.5)] dark:text-gray-400">
          {title}
        </span>
        {!open && summary && (
          <span className="ml-1.5 text-[12.5px] text-[#787774] dark:text-gray-400 truncate">{summary}</span>
        )}
      </button>
      {open && <div className="pt-1 pb-2">{children}</div>}
    </div>
  );
}
